import { createContext } from 'react';
import { IFileData, ICreateUpdateFirmware, TFirmwareType } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface ICreateFirmwareState {
	typeSelectedFirmware: TFirmwareType;
	nameOfFirmware: string;
	versionOfFirmware: string;
	description: string;
	fileData: IFileData;
	dataForSubmit: ICreateUpdateFirmware | null;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createFirmwareInitialState: ICreateFirmwareState = {
	typeSelectedFirmware: 1,
	nameOfFirmware: '',
	versionOfFirmware: '',
	description: '',
	fileData: {
		fileId: '',
		fileHash: null,
		fileName: null,
	},
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateFirmwareContext extends ICreateFirmwareState {
	setTypeSelectedFirmware(value: TFirmwareType): void;
	changeNameOfFirmware(value: string): void;
	changeVersionOfFirmware(value: string): void;
	changeDescription(value: string): void;
	changeFileData(value: IFileData): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setDataForSubmit(value: ICreateUpdateFirmware | null): void;
	resetFields(): void;
}

export const CreateFirmwareContext = createContext<ICreateFirmwareContext>({
	setTypeSelectedFirmware: () => undefined,
	changeNameOfFirmware: () => undefined,
	changeVersionOfFirmware: () => undefined,
	changeDescription: () => undefined,
	changeFileData: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createFirmwareInitialState,
});
